export default __webpack_public_path__ + "static/media/1428.e8358646.png";